// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1RN2z","label":"SetPasswdForm_label__3oQK-"};